import React from "react";
import { Input, Form } from "antd";
import cx from "classnames";
import PropTypes from "prop-types";

import styles from "./Input.module.scss";

export default function InputPassword({
  width,
  label,
  classLabel,
  children,
  type,
  classInput,
  mandatory = true,
  ...rest
}) {
  const noteLabel = label => {
    return (
      <span>
        <span style={{ color: "red" }}>* </span>
        {label}
      </span>
    );
  };

  return (
    <div>
      <Form.Item
        label={mandatory ? noteLabel(label) : label}
        className={cx(styles.FormItem, classLabel)}
      >
        <Input.Password
          style={{ width: width || "100%" }}
          className={cx(styles[type], styles.Input, classInput)}
          {...rest}
        >
          {children}
        </Input.Password>
      </Form.Item>
    </div>
  );
}
InputPassword.propTypes = {
  width: PropTypes.string,
};
